import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RdstationService} from '../../core/services/rdstation.service';

@Component({
  selector: 'app-landing-permanente',
  templateUrl: './landing-permanente.component.html',
  styleUrls: ['./landing-permanente.component.sass']
})
export class LandingPermanenteComponent implements OnInit {
  public nome;
  public email;
  public telefone;
  public parameters;
  public formEnviado = false;

  private sub: any;

  constructor(public rdStationService: RdstationService, private route: ActivatedRoute, private router: Router) { }



  scroll(el) {

    const yOffset = -150;
    const element = document.getElementById(el);
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({top: y, behavior: 'smooth'});
  }

  ngOnInit() {
    this.sub = this.route.queryParamMap.subscribe(params => this.parameters = params);
  }

  async landingPost() {
    const result = await this.rdStationService.landingPost({
      token_rdstation: '2c6230cd8f400ecd878194ac5872391f',
      identificador: 'formulario-landing-page-novo-site',
      _is: '6',
      c_utmz: '',
      traffic_source: '',
      client_id: '',
      redirect_to: 'http://localhost:4200/landing-permanente#obrigado',
      _doe: '',
      emP7yF13ld: '',
      thankyou_message: 'Obrigado',
      sh0uldN07ch4ng3: 'should_not_change',
      name: this.nome,
      email: this.email,
      personal_phone: this.telefone,
      'custom_fields[697221]': this.parameters.params.utm_source,
      'custom_fields[697222]': this.parameters.params.utm_medium,
      'custom_fields[697224]': this.parameters.params.utm_campaign,
      'custom_fields[697225]': this.parameters.params.utm_term,
      'custom_fields[697226]': this.parameters.params.utm_content
    });

    if (result.status === 200) {
      this.nome = '';
      this.email = '';
      this.telefone = '';
      this.formEnviado = true;
      this.router.navigate(['/faca-parte-obrigado']);
    }
  }

  indicarMais() {
    this.formEnviado = false;
  }
}
